const persons = {
	title: "Persons",
	new_person: "New Person",
	edit_person: "Edit Person: {name}",
	view_person: "View Person: {name}",
	person_title: "Person Details",
	list_title: "List of Persons",
	list_subtitle: "Manage persons",
	id: "ID",
	first_name: "First Name",
	last_name: "Last Name",
	middle_name: "Middle Name",
	mobile: "Mobile Phone",
	email: "Email Address",
	comments: "Comments",
	create_as_user: "Create as User",
};
export default persons;